import { Link } from 'react-router-dom';
import { endpointHref, type ApiEndpoint } from '../api-endpoints';

interface OnThisPageProps {
  endpoints: ApiEndpoint[];
}

/**
 * In-page table of contents for API reference pages — links to each #hash.
 */
export function OnThisPage({ endpoints }: OnThisPageProps) {
  if (endpoints.length === 0) return null;

  return (
    <nav className="api-on-this-page" aria-label="On this page">
      <span className="api-on-this-page-label">On this page</span>
      <ul className="api-on-this-page-list">
        {endpoints.map((ep) => (
          <li key={ep.id}>
            <Link to={endpointHref(ep)} className="api-on-this-page-link">
              <span className={`api-method api-method-${ep.method.toLowerCase()}`}>{ep.method}</span>
              <span className="api-on-this-page-path">{ep.path}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
